import { computed } from 'vue';
import { get } from 'lodash-es';

export default function useSpacing(
  settings,
  { paddingPath = 'padding', marginPath = 'margin' } = {},
  { defaultMargin = '0', defaultPadding = '1rem' } = {},
) {
  const margin = computed(() => {
    const marginValue = get(settings.value, marginPath);

    if (marginValue) {
      const {
        top, right, bottom, left,
      } = marginValue;
      return `${top}px ${right}px ${bottom}px ${left}px`;
    }

    return defaultMargin;
  });

  const padding = computed(() => {
    const paddingValue = get(settings.value, paddingPath);
    if (paddingValue) {
      const {
        top, right, bottom, left,
      } = paddingValue;
      return `${top}px ${right}px ${bottom}px ${left}px`;
    }

    return defaultPadding;
  });

  return {
    margin,
    padding,
  };
}
